// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2O93x","text":"_1ULFF","timestamp":"Nhfb_","with-event":"_15sU0","event":"n0GyL"};